import React from 'react';

import { WebsiteImagePanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const WebsiteImagePanelPage = props => (
  <WebsiteImagePanel {...props} notificationApi={notificationApi} />
);
